import { IVanFetch } from 'src/models/IVan';

type IFilterVan = Pick<IVanFetch, 'id' | 'location' | 'make' | 'type' | 'year'>;

const createVanURL = (filter: IFilterVan) => {
  const location = filter.location.split(' - ');
  const city = location[1].replaceAll(' ', '');
  const make = filter.make!.replaceAll(' ', '');

  return `/van/${location[0]}/${city}/${make}/${filter.type}/${filter.year}/143${filter.id}`;
};

export default createVanURL;
